// extracted by mini-css-extract-plugin
export default {"containerCharacter":"Character_containerCharacter__kentt"};